"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var html_react_parser_1 = __importDefault(require("html-react-parser"));
var material_1 = require("@mui/material");
var ContentContext_1 = __importDefault(require("@/frontend/react/context/ContentContext"));
var icons_1 = require("../icons");
var classes = {
    main: {
        border: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
        borderRadius: '10px',
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
    },
    header: {
        background: 'linear-gradient(84.06deg, rgba(0, 0, 0, 0.9) 0%, rgba(64, 64, 64, 0.9) 100%)',
        py: 4,
        px: 8,
        borderBottom: function (theme) { return "1px solid ".concat(theme.palette.primary.main); },
        borderRadius: '10px 10px 0 0',
        color: 'white',
        display: 'flex',
        alignItems: 'center',
        position: 'relative',
        '&>h4': {
            fontSize: '24px',
            margin: 0,
        },
        zIndex: 1,
    },
    rfIcon: {
        position: { xs: 'block', lg: 'absolute' },
        right: '30px',
        top: '10px',
        fontSize: { xs: '4rem', lg: '5rem' },
        stroke: 'transparent !important',
        zIndex: 2,
    },
    content: {
        p: { lg: '10px 10px 0 0', xs: '0 1rem' },
        backgroundColor: 'white',
        borderRadius: '0 0 10px 10px',
        display: 'flex',
        flexDirection: { xs: 'column', lg: 'row' },
    },
    column: {
        display: 'flex',
        flexDirection: { xs: 'row-reverse', lg: 'row' },
        alignItems: 'center',
        '&>*+*': {
            ml: { lg: 3 },
            mr: { xs: 3 },
        },
        '&>img': {
            alignSelf: 'flex-end',
        },
        '& h5': {
            color: function (theme) { return theme.palette.secondary.main; },
            fontSize: '20px',
            fontWeight: 700,
            margin: 0,
            marginBottom: 4,
        },
        '& p': {
            mt: 1,
        },
    },
};
var ApplyWithRFCard = function () {
    var rfCard = (0, react_1.useContext)(ContentContext_1.default).rfCard;
    return ((0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.main }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ sx: classes.header }, { children: [(0, html_react_parser_1.default)("".concat(rfCard.title)), (0, jsx_runtime_1.jsx)(icons_1.RFIcon, { sx: classes.rfIcon })] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ container: true, sx: classes.content, spacing: 4 }, { children: [(0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, md: 12, lg: 6, sx: classes.column }, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/money.svg" }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, html_react_parser_1.default)("".concat(rfCard.leftColumn)) })] })), (0, jsx_runtime_1.jsxs)(material_1.Grid, __assign({ item: true, md: 12, lg: 6, sx: classes.column }, { children: [(0, jsx_runtime_1.jsx)("img", { src: "/img/saly.svg" }), (0, jsx_runtime_1.jsx)(material_1.Box, { children: (0, html_react_parser_1.default)("".concat(rfCard.rightColumn)) })] }))] }))] })));
};
exports.default = ApplyWithRFCard;
